module.exports = "/static/media/girl-with-phone.2f17ced4.png";